'use strict';

var Typeahead = require('./Typeahead.react');

module.exports = Typeahead;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap-typeahead/lib/index.js
 ** module id = 643
 ** module chunks = 0
 **/